let elDlg; // 弹窗全局唯一

const KEY = 'simple-dialog-start-time';

function needShowAfterDays(days, ruleKey, detailId) {
  if (days > 0) {
    const time = localStorage.getItem(`${KEY}-${ruleKey}-${detailId}`);
    if (time) {
      const start = new Date(time).getTime();
      const now = new Date().getTime();
      // xx天内不再展示，xx天后再展示
      if (((now - start) / 1000 / 60 / 60 / 24) > days) {
        return true;
      }
      // 没展示，就不用重新记录时间
      return false;
    }
    // 从未没记录过时间
    localStorage.setItem(`${KEY}-${ruleKey}-${detailId}`, new Date());
  }
  return true;
}

function show(config = {}) {
  const {
    btn1Callback = () => {},
    btn1Text,
    btn2Callback = () => {},
    btn2Text,
    onShow = () => {},
    content = '',
    title = '',
    showAfterDays,
    className = '',
    showClose = false,
    key: ruleKey = '',
    detailId = '',
  } = config;
  if (!elDlg) {
    elDlg = document.createElement('div');
    elDlg.setAttribute('class', 'bc-simple-dialog');

    elDlg.innerHTML = `
      <div class="simple-dialog-wrap ${className}">
        <div class="simple-dialog-con">
          <div class="simple-dialog-title">${title}</div>
          <div class="simple-dialog-close" style="display:${showClose ? 'block' : 'none'};">
            <i class="next-icon next-icon-close next-icon-large"></i>
          </div>
          <div class="simple-dialog-content">${content}</div>
          <div class="simple-dialog-actions">
            ${btn1Text ? `<button class="simple-dialog-btn1">${btn1Text}</button>` : ''}
            ${btn2Text ? `<button class="simple-dialog-btn2">${btn2Text}</button>` : ''}
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(elDlg);
    onShow();
    btn1Text && elDlg.querySelector('.simple-dialog-btn1').addEventListener('click', btn1Callback);
    btn2Text && elDlg.querySelector('.simple-dialog-btn2').addEventListener('click', btn2Callback);
    elDlg.querySelector('.simple-dialog-close').addEventListener('click', hide);
  }

  if (needShowAfterDays(showAfterDays, ruleKey, detailId)) {
    // 展示了就重新记录时间
    localStorage.setItem(`${KEY}-${ruleKey}-${detailId}`, new Date());
    elDlg.style.display = 'block';
  }

  try {
    const p = elDlg.querySelector('.simple-dialog-content p');
    const con = elDlg.querySelector('.simple-dialog-con');
    con.style.height = `${p.clientHeight + 130}px`;
  } catch (error) {}
}

function hide() {
  elDlg.style.display = 'none';
}

const simpleDialog = {
  show,
  hide,
};

export default simpleDialog;
